import { z } from 'zod';
import { requiredString } from '../../helper';

export const termsConditionsAndAgreements = z.object({
  beOver18: requiredString(),
  haveAustralianIncome: requiredString(),
  //TODO: this field has to be removed later
  haveFilledOwnDetails: z.string().optional(),
  consentPrivacyPolicy: requiredString(),
  consentCreditReport: requiredString(),
  consentElectronicCommunication: requiredString(),
  creditAndTermsAgreement: requiredString(),
  beGovSchemeHomeOwner: requiredString(),
  consentGovSchemeTerms: requiredString(),
  businessEligibilityCriteriaAgreement: requiredString(),
  haveActiveMortgage: requiredString(),
  haveEligibleNetIncome: requiredString(),
  consentCreditCheck: requiredString(),
  capacityToPay: requiredString(),
  enterprisePartnerTerms: requiredString(),
  //TODO: make this mandatory later
  consentCustomerDeclaration: z.string().optional(),
  haveReadDisclosureOfCreditInformation: z.string().optional(),
  beCompletedPropertyOwner: z.string().optional(),
});

export const directDebitAgreement = z.object({
  directDebitStatement: requiredString(),
  authoriseBrighteStatement: requiredString(),
});

export const capacityToPayAgreement = termsConditionsAndAgreements.pick({
  capacityToPay: true,
});
